<template>
  <div class="wrapper">
    <div class="main">
      <div class="section">
        <div class="container">
          <md-card class="bar-breadcrumb">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item">
                  <router-link to="/">{{ $t("主页") }}</router-link>
                  <span class="breadcrumb-slash">/</span>
                  <span>{{ $t("更改密碼") }}</span>
                </div>
              </div>
            </md-card-content>
          </md-card>

          <md-card>
            <div class="container">
              <div class="md-title title-category">{{ $t("更改密碼") }}</div>
            </div>

            <md-card-content>
              <form novalidate class="md-layout" @submit.prevent="validateUser">
                <div class="md-layout-item">
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="login_error.old_password">
                        <label for="name">{{ $t("現有密碼") }}</label>
                        <md-input
                          name="old_password"
                          id="old_password"
                          v-model="old_password"
                          @focus="clearError('old_password')"
                        />
                      </md-field>
                    </div>
                  </div>

                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="login_error.new_password">
                        <label for="name">{{ $t("新密碼") }}</label>
                        <md-input
                          name="new_password"
                          id="new_password"
                          v-model="new_password"
                          type="password"
                          @focus="clearError('new_password')"
                        />
                      </md-field>
                    </div>
                  </div>

                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="login_error.new_password_confirm">
                        <label for="name">{{ $t("確認新密碼") }}</label>
                        <md-input
                          name="new_password_confirm"
                          id="new_password_confirm"
                          v-model="new_password_confirm"
                          type="password"
                          @focus="clearError('new_password_confirm')"
                        />
                      </md-field>
                    </div>
                  </div>
                </div>
              </form>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100 container-checkout_btn">
                  <md-button type="submit" class="md-primary" @click="onClickChangePassword">{{ $t("提交") }}</md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      eventHub: window.eventHub,
      login_error:{
        username : false,
        password : false,
      },
    };
  },
  methods: {
    clearError (){

    },

    async onClickChangePassword() {
      if (this.old_password == "" || this.new_password == "") {
        alert("Please enter password");
        return;
      }

      if (this.new_password != this.new_password_confirm) {
        alert("New password not match");
        return;
      }
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "member_change_password.php",
        data: {
            member_id: this.$store.state.member_id,
          old_password: this.old_password,
          new_password: this.new_password
        }
      });

      if (response.data.status == "success") {
          alert("更改成功");
      } else {
        alert(response.data.message);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.root-container {
  padding-top: 150px;
}
</style>